<!--
  画面名：-
  概要： 共通ダイアログコンポーネント
  備考： -
-->

<!-- HTML -->
<template>
  <!--  チェックリストダイアログ要素  -->
  <v-dialog v-model="isDialog" scrollable content-class="foodRegistrationWrapper" max-width="1400px" class="dialogWrapper">
    <!--  ページ全体を囲う要素  -->
    <div :class="{'overflowWrapper':isEditFood || isAddFood}" id="scrollTarget">
      <div class="wrapper">
        <!-- アレルゲンを表示 -->
        <Allergen
          v-show="isAllergen"
          @send="showDialog"
          :isRefer="true"
          :allergenchecked="allergen"
          ref="refAllergen"
        />
        <!-- 食材登録フォームを表示 -->
        <FoodRegistrationForm
          v-if="isEditFood || isAddFood"
          :isEditFood="isEditFood"
          :isAddFood="isAddFood"
          :editItemData="editItemData"
          :isPlan="isPlan"
          @confirm="save"
          @templateFoodUpdate="updateTemplate"
          @templateFoodInsert="insertTemplate"
          @setDisabled="setDisabled"
          @changeFlag2Add="changeFlag2Add"
          @showDialog="showDialog"
          ref="foodRegistration"
        />
      </div>
    </div>
    <span></span>
    <v-card-actions>
      <v-spacer />
      <!-- 保存ボタン -->
      <v-btn
        form="form"
        v-if="!isAllergen"
        color="blue darken-1"
        flat
        @click="dataValidate"
      >
        {{$language.LabelSave}}
      </v-btn>
      <!-- 閉じるボタン -->
      <v-btn color="blue darken-1" flat @click="closeDialog">
        {{$language.LabelClose}}
      </v-btn>
    </v-card-actions>
    <!-- 保存ダイアログ -->
    <SaveDialog
      ref="refSaveDialog"
      @set="closeDialog"
    />
  </v-dialog>
</template>
<!-- /HTML -->

<script>
// アレルゲン一覧
import Allergen from '@/components/parts/common/Allergen'
// 食材登録フォーム
import FoodRegistrationForm from '@/components/parts/common/FoodRegistrationForm'
// 保存用モーダル
import SaveDialog from '@/components/parts/common/SaveDialog'

export default {
  // 子（外部）コンポーネント設定
  components: {
    // アレルゲン一覧
    Allergen,
    // 食材登録フォーム
    FoodRegistrationForm,
    // 保存ダイアログ
    SaveDialog
  },
  // 親コンポーネントから値を受け取る
  props: {
    // 計画策定からの判定
    isPlan: { type: Boolean, default: false }
  },
  // 初期値設定
  data () {
    return {
      // ダイアログの表示切替
      isDialog: false,
      isAllergen: false,
      isEditFood: false,
      isAddFood: false,
      allergen: '',
      editItemData: {},
      isAbled: false
    }
  },
  // Vue インスタンスを監視
  watch: {
    // ダイアログの表示判定を監視
    isDialog () {
      // ダイアログの表示判定がfalseの時、全てのコンポーネントを非表示にする
      if (!this.isDialog) {
        this.isAllergen = false
        this.isEditFood = false
        this.isAddFood = false
        let st = document.getElementById('scrollTarget')
        st.attributes[1].ownerElement.scrollTop = 0
      }
    }
  },
  mounted () {
  },
  // コンポーネントの処理を記載
  methods: {
    handleScroll (e) {
      console.log(e.target.scrollTop)
    },
    // ボタンの使用可能判定
    setDisabled (bool) {
      this.isAbled = bool
    },
    // 確認用ダイアログを表示
    save (itemValue) {
      this.foodSend(itemValue)
    },
    // 雛形食材を事業者食材テーブルに追加する処理
    insertTemplate (itemValue) {
      this.isAddFood = true
      this.isEditFood = false
      this.foodSend(itemValue)
    },
    // 事業者食材テーブルに追加する処理
    updateTemplate (itemValue) {
      this.isAddFood = false
      this.isEditFood = true
      this.foodSend(itemValue)
    },
    // ダイアログに表示するコンポーネントを決定する
    changeView (value) {
      if (value === 'isAllergen') {
        this.isAllergen = true
      } else if (value === 'isEditFood') {
        this.isEditFood = true
      } else if (value === 'isAddFood') {
        this.isAddFood = true
      }
    },
    // valueには食材データを格納。親コンポーネントから発火。
    getEditData (value) {
      this.editItemData = value
    },
    // valueには食材データを格納。親コンポーネントから発火。
    getAllergenData (value) {
      this.allergen = value
      this.$refs.refAllergen.makeAllergenFrame()
    },
    // valueには食材データを格納。親コンポーネントから発火。
    deleteEditData (value) {
      this.editItemData = {}
    },
    // ダイアログを表示する。親コンポーネントから発火。
    showDialog () {
      this.isDialog = true
    },
    // ダイアログを閉じる
    closeDialog () {
      this.$emit('foodDataReload')
      this.isDialog = false
    },
    // DBにデータを送る
    dataValidate () {
      if (this.isAddFood || this.isEditFood) {
        // 食材追加の処理
        this.$refs.foodRegistration.validate()
      }
    },
    // コピーして作成ボタンが押下された際、編集機能から追加機能に切り替える
    changeFlag2Add () {
      this.isAddFood = true
      this.isEditFood = false
      this.$refs.foodRegistration.changeBaseId()
    },
    // 食材データをDBに保存
    foodSend (foodData) {
      // コールバック関数用にthisを変数に格納
      let self = this
      // コールバック関数を作成する
      function callbackSuccess () {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        self.$refs.refSaveDialog.openDialog()
      }
      foodData.callback = callbackSuccess
      if (this.isPlan) {
        // 事業者の食材一覧を参照している場合
        if (this.isAddFood) {
          // 事業者DBに食材データを保存
          this.$store.dispatch('managementFunction/actionInsertFoodData', foodData)
        } else if (this.isEditFood) {
          // 事業者DBの食材データを編集
          this.$store.dispatch('managementFunction/actionUpdateFoodData', foodData)
        }
      } else {
        // 食材データ雛形を参照している場合
        if (this.isAddFood) {
          // 雛形に食材データを追加
          this.$store.dispatch('systemConfig/actionInsertFoodData', foodData)
        } else if (this.isEditFood) {
          // 雛形の食材データを編集
          this.$store.dispatch('systemConfig/actionUpdateFoodData', foodData)
        }
      }
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss">
  @import '@/assets/scss/common/dialog.scss';
</style>
